module.exports = __webpack_public_path__ + "img/20190902151714766.0189898a.jpg";